import React from 'react';

export interface TextInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: 'text' | 'url' | 'email';
  autoComplete?: string;
  inputMode?: 'text' | 'url' | 'email' | 'tel' | 'numeric' | 'decimal' | 'search';
  name: string;
  autoFocus?: boolean;
  spellCheck?: boolean;
  /** aria-label when no visible label is rendered */
  ariaLabel?: string;
}

/**
 * Big single-line text input. Used for §A name, §A website URL, etc.
 * Brand: 16px placeholder, IBM Plex Sans, blue focus ring at 3px.
 */
export function TextInput({
  value,
  onChange,
  placeholder,
  type = 'text',
  autoComplete,
  inputMode,
  name,
  autoFocus,
  spellCheck,
  ariaLabel,
}: TextInputProps) {
  return (
    <input
      className="aa-text-input"
      type={type}
      name={name}
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      autoComplete={autoComplete}
      inputMode={inputMode}
      autoFocus={autoFocus}
      spellCheck={spellCheck}
      aria-label={ariaLabel}
    />
  );
}

export default TextInput;
